import TagsNav from './tags-nav.vue'
export default TagsNav



// WEBPACK FOOTER //
// ./src/view/main/components/tags-nav/index.js